import { ChangeDetectionStrategy, Inject, Component, ChangeDetectorRef, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerNotificationService } from '../main-page/customer-notification.service';
import { AppUtils } from '../utils/app-utils';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT, NgClass, NgFor, NgIf } from '@angular/common';
import { Subscription, Observable, distinctUntilChanged } from 'rxjs';
import { OneWebComponentsAngularModule } from '@one/angular';
import { snackbarService } from '@one/web-components';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LinkService } from '../../core/services/link.service';
import { FileUploadSingleComponent } from '../file-upload-single/file-upload-single.component';
import { QnSbnDataService } from './../services/qn-sbn-data-service.service';
import { QnSbnService } from './../services/qn-sbn-service.service';
import { watchIsLoggedIn, login, logout } from 'shell-browser/auth.js';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgShellRxjsWrapperService } from '../../shell/ng-shell-wrapper.service';

@UntilDestroy()
@Component({
  selector: 'dl-customer-notification-details',
  standalone: true,
  imports: [OneWebComponentsAngularModule, NgIf, NgFor, NgClass, ReactiveFormsModule, TranslocoModule, FileUploadSingleComponent],
  templateUrl: './customer-notification-details.component.html',
  styleUrl: './customer-notification-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CustomerNotificationDetailsComponent implements OnInit, OnDestroy {
  readonly translocoService = inject(TranslocoService);
  readonly ngShellService = inject(NgShellRxjsWrapperService);
  isLoggedIn$: Observable<boolean>;
  isLoggedIn: boolean = false;
  public isDisabled = true;
  public notificationDataObj: any;
  public feedBackDetails: any;
  public notificationDetailsObj: any;
  public customerDataObj: any;
  public feedBackData: any;
  public customerFeedbackItems: any;
  public feedbackobj: any;
  public feedbackDataForm: FormGroup;
  public isFeedBackSubmitted = false;
  public isCompleted = false;
  public userFileSize = { size: 0, type: '' };
  public notificationType = '';
  public isNonDialogSBNType = false;
  public isApIFailed = false;
  public msgAPIFailed = '';
  public remindersData = [];
  public isReminderDisabled = false;
  public ContactNotificationObj: any;
  private _accSelectorSubscription: Subscription | undefined;
  public accSelector:string = '';
  public detailsAPIRes:any;
  public spinBool:boolean = false;
  public mainPageLink:string = '';
  public fileData;
  public publicKeyToken: string | null = null;
  public contactNotificationId: string | null = null;
  public isNonDialogUser:boolean = false;

  public constructor(
    @Inject(DOCUMENT) private document: Document,
    public cdr: ChangeDetectorRef,
    public fb: FormBuilder,
    public appUtil: AppUtils,
    public router: Router,
    public customerservice: CustomerNotificationService,
    public activateroute: ActivatedRoute,
    public linkService: LinkService,
    private _QnSbnDataService:QnSbnDataService,
    private _QnSbnService: QnSbnService
  ){}

  public ngOnDestroy(): void {
    this._accSelectorSubscription?.unsubscribe();
  }

  ngOnInit(): void {

    // Subscribe to account selector changes
    this._accSelectorSubscription = this.customerservice.accountSelector$.subscribe(
      (selector: string) => {
        this.accSelector = selector;
        this.cdr.detectChanges();
      }
    );

    const urlQueryString = window.location.search;
    const parameters = new URLSearchParams(urlQueryString);
    const notificationId = parameters.get('notificationId');
    this.publicKeyToken = parameters.get('publicKeyToken');
    this.contactNotificationId = parameters.get('contactNotificationId');

    // No notification id passed, redirect back to main
    if (!notificationId) {
      this.router.navigate(['main']);
    }

    // Non dialog user request
    if (this.publicKeyToken) {
      this.isNonDialogUser = true;
      this.requestNotificationDetails(urlQueryString);
    }
    // Dialog user request
    else {
      this.getIsLoggedIn();
        this.isLoggedIn$
        .pipe(
            distinctUntilChanged(), // Only emit when value changes
            untilDestroyed(this)
          )
        .subscribe(async isLoggedIn => {
          this.isLoggedIn = isLoggedIn;
          if (isLoggedIn) {
            console.log('User is logged in');
            this.requestNotificationDetails(urlQueryString);
          }else {
            console.log('User is logged out');
            login();
            return;
          }
        });
    }
  }

  private getIsLoggedIn(): void {
      this.isLoggedIn$ = this.ngShellService.toObservable(watchIsLoggedIn);
    }

  private requestNotificationDetails(urlQueryString: string) : void {
    this.customerservice.getNotificationDetailsDirectLink(urlQueryString).subscribe(
        (data: any) => {
          if (Object.keys(data).length > 0) {
            this.detailsAPIRes = data;
            this.notificationDetailsInit(data, this.accSelector);
          } else {
            const errorMessage = this.appUtil.getTranslatedMessage('203');
            this.customerservice.httpErrorHandler({ status: 203 }, errorMessage);
            this.isApIFailed = true;
            this.msgAPIFailed = errorMessage;
            this.cdr.detectChanges();
          }
        },
        (error: HttpErrorResponse) => {
          this.isApIFailed = true;
          let errorMessage = '';
          if (error.status === 403 || error.status === 404) {
            errorMessage = this.appUtil.getTranslatedMessage(error.status.toString());
          } else {
            errorMessage = this.appUtil.getTranslatedMessage('detailFailed');
          }
          snackbarService.show({
              message: this.translocoService.translate(errorMessage), 
              snackbarProps: {
                status: 'alarm',
                direction: 'horizontal',
                showClose: true,
                elevated: false,
                duration: 4000,
                verticalPlacement: 'top',
                horizontalPlacement: 'right',
              }
            });
            setTimeout(() => {
              this.router.navigateByUrl(this.mainPageLink);
            }, 5000);
          this.cdr.detectChanges();
        }
      );
  }
  
  public notificationDetailsInit(data: any, accSelector): void {

    if(accSelector === 'My notifications' && accSelector !== undefined){
      this.notificationDetailsObj = Array.isArray(data.ContactNotification) ? data.ContactNotification[0] : data.ContactNotification;
    }else{
      this.notificationDetailsObj = Array.isArray(data.AccountNotification) ? data.AccountNotification[0] : data.AccountNotification;
    }

    this.customerDataObj = Array.isArray(data.Notification) ? data.Notification[0] : data.Notification;
    this.ContactNotificationObj = Array.isArray(data.ContactNotification) ? data.ContactNotification[0] : data.ContactNotification;
    this.notificationType = this.customerDataObj?.Type || '';
    this.isNonDialogSBNType = this.isNonDialogUser && this.notificationType === 'SBN' ? true : false;
    const localId = this.notificationDetailsObj ? this.notificationDetailsObj.LocalId : '';
    this.customerservice.setLocalId(localId);


    // Only consider NotificationReminders for remindersData
    if (Array.isArray(this.customerDataObj?.NotificationReminders) && this.customerDataObj.NotificationReminders.length > 0) {
      this.remindersData = this.customerDataObj.NotificationReminders.filter(reItem => reItem.ReminderSendStatus === "Delivered").reverse();
    } else {
      this.remindersData = [];
    }

    this.isReminderDisabled = this.remindersData.length === 1;
    this.feedbackDataForm = this.fb.group({});
    
    if (this.notificationDetailsObj && (this.notificationDetailsObj.CustomerStatus || this.notificationDetailsObj.Status) && this.customerDataObj.Status) {
      
      this.isFeedBackSubmitted = this.notificationDetailsObj.CustomerStatus === 'Feedback Submitted' 
      || this.notificationDetailsObj.CustomerStatus === 'Feedback Received'
      || this.notificationDetailsObj.Status === 'Feedback Submitted'
      || this.notificationDetailsObj.Status === 'Feedback Received';

      this.isCompleted = this.customerDataObj.Status === 'Completed';
      
    }

    if (this.customerDataObj && this.customerDataObj.CustomerFeedbackItems) {
      this.feedbackobj = this.customerDataObj.CustomerFeedbackItems;
      this.feedbackobj.forEach(formItem => {
        const response = this.detailsAPIRes.AccountNotification?.[0]?.FeedbackResponseItems?.find(
          data => data.FeedbackResponseItemId === formItem.FeebackItemId
        );
        if(formItem.FeedbackItemMandatory && formItem.FeedbackItemMandatory === 'Optional') {
          let resValue;
          if (response && response.FeedbackResponseItemLabel) {
            resValue = response.FeedbackResponseItemLabel;
          } else if (formItem.FeedbackItemType === 'Checkbox') {
            resValue = false;
          }else{
            resValue = '';
          }

          if (formItem.FeedbackItemType === 'Checkbox') {
            this.feedbackDataForm.addControl(
              this.getFormControl(formItem.FeebackItemId),
              this.fb.control({ value: resValue, disabled: (this.isFeedBackSubmitted || this.isCompleted) })
            );
          } else if (formItem.FeedbackItemType === 'Attachment') {
            this.feedbackDataForm.addControl(
              this.getFormControl(formItem.FeebackItemId),
              this.fb.control({ value: resValue, disabled: (this.isFeedBackSubmitted || this.isCompleted) })
            );
          } else {
            this.feedbackDataForm.addControl(
              this.getFormControl(formItem.FeebackItemId),
              this.fb.control({ value: resValue, disabled: (this.isFeedBackSubmitted || this.isCompleted) })
            );
          }
        } else {
          let resValue;
          if(response && response.FeedbackResponseItemLabel ){
            resValue = response.FeedbackResponseItemLabel
          }else if(formItem.FeedbackItemType === 'Checkbox'){
            resValue = false;
          }else{
            resValue = '';
          }
          if (formItem.FeedbackItemType === 'Checkbox') {
            this.feedbackDataForm.addControl(
              this.getFormControl(formItem.FeebackItemId),
              this.fb.control({ value: resValue, disabled: (this.isFeedBackSubmitted || this.isCompleted) }, [Validators.requiredTrue])
            );
          } else if (formItem.FeedbackItemType === 'Attachment') {
            this.feedbackDataForm.addControl(
              this.getFormControl(formItem.FeebackItemId),
              this.fb.control({ value: resValue, disabled: (this.isFeedBackSubmitted || this.isCompleted) }, [Validators.required])
            );
          }else {
            
            this.feedbackDataForm.addControl(
             
              this.getFormControl(formItem.FeebackItemId),
              this.fb.control({ value: resValue, disabled: (this.isFeedBackSubmitted || this.isCompleted) }, [Validators.required])
            );
          }
        }
      });
    }

    this.cdr.detectChanges();
  }

  onFileSelected(file: File | null, feedbackItem: any): void {
  const controlName = this.getFormControl(feedbackItem.FeebackItemId);
  const control = this.feedbackDataForm.get(controlName);
  if (control) {
    control.setValue(file);
    control.markAsTouched();
    control.updateValueAndValidity();
  }
}

  public enablesubmit(): void {
    this.isDisabled = false;
  }

  public getSbtBtn(btnStatus: string): string {
    switch (btnStatus) {
      case 'New':
        return 'sbt-btn';
      case 'Read':
        return 'sbt-btn';
      case 'Reminder':
        return 'sbt-btn';
      case 'Feedback Overdue':
        return 'sbt-btn';
      case 'Feedback Submitted':
        return 'bck-btn';
      case 'Feedback Received':
        return 'bck-btn';
      case 'Completed':
        return 'bck-btn';
      default:
        return 'bck-btn';
    }
  }

  public getSubmitFormData(): void {
    const feedbackVar: any = [];
    const feedbackresArr = this.feedbackDataForm.value;
    const feedbackresponseVal = Object.values(feedbackresArr);

    this.feedbackobj.forEach(formItem => {
      feedbackVar.push({
        FeedbackResponseItemId: formItem.FeebackItemId,
        FeedbackResponseItemLabel: feedbackresponseVal[formItem.FeebackItemId]
      });
    });

    this._QnSbnDataService.mappingData$.subscribe(fileData=>{
      this.fileData= fileData
    })
    console.log('fileData--',this.fileData);
    console.log("notification data", this.notificationDetailsObj)
    this.feedBackData = {
      NotificationId: this.notificationDetailsObj.NotificationId,
      NotificationType: this.notificationDetailsObj.Type,
      ReadAndUnderstood: true, // this.readconfirm.value,
      WillTakeAction: true, // this.actionconfirm.value,
      CustomerFeedbackResponseItems: feedbackVar,
      CustomerId: this.ContactNotificationObj.CustomerId || '',
      ContactNotificationId: this.ContactNotificationObj.ContactNotificationId || '',
      CustomerContactEmail: this.ContactNotificationObj.CustomerContactEmail || '',
      CustomerFeedbackAttachment: this.fileData?.customerFeedbackAttachment?.[this.notificationDetailsObj.NotificationId] || []
    };
    if (this.isNonDialogUser) {
      this.feedBackData.PublicKeyToken = this.publicKeyToken;
    }
  }

  public SubmitFeedback(): void {
    this.spinBool = true;
    this.getSubmitFormData();
    let sendNData;
    if(!this._QnSbnDataService.isEmpty(this.feedBackData)){
      sendNData = this._QnSbnDataService.saveNcloseData(this.feedBackData);
    } 
    let fileData = this._QnSbnDataService.fileUploadData(this.feedBackData);
    sessionStorage.setItem('reloadOverview', 'true');
    
    if(fileData.length > 0){
      const allFiles = fileData.flat();
      const filesToUpload = allFiles.filter(f => f.uploadFile); 
      for(let f=0;f<=(filesToUpload.length-1);f++){
        if(filesToUpload[f].uploadFile) {
          this._QnSbnService.dataToBeSaveOnS3(sendNData.ContactNotificationId,filesToUpload[f],this.feedBackData['NotificationId'],(f==(filesToUpload.length-1)) ? true :false,this.isNonDialogUser ? this.publicKeyToken : null);
        }
      }        
    }
    this.customerservice.putService(this.feedBackData).subscribe(
      (response: HttpResponse<any>) => {
        this.spinBool = false;
        this.customerservice.storeNotificationTableData = null;
        const feedbackSubmitted = this.appUtil.getTranslatedMessage('FeedbackSubmitted');
        snackbarService.show({
          message: this.translocoService.translate(feedbackSubmitted), 
          snackbarProps: {
            status: 'positive',
            direction: 'horizontal',
            showClose: true,
            elevated: false,
            duration: 3000,
            verticalPlacement: 'top',
            horizontalPlacement: 'right',
          }
        });
        if (this.isNonDialogUser) {
          this.router.navigate(['welcome']);
        } else {
          this.router.navigateByUrl(this.mainPageLink);
        }
      },
      (error: HttpErrorResponse) => {
        this.spinBool = false;
        const feedbackFailed = this.appUtil.getTranslatedMessage('FeedbackFailed');
        snackbarService.show({
          message: this.translocoService.translate(feedbackFailed), 
          snackbarProps: {
            status: 'alarm',
            direction: 'horizontal',
            showClose: true,
            elevated: false,
            duration: 5000,
            verticalPlacement: 'top',
            horizontalPlacement: 'right',
          }
        });
      }
    );  
}

  public nonDialogConfirmFeedback(): void {
    this.getSubmitFormData();
    //this.SubmitFeedback();
    this.router.navigateByUrl('/contact-details', { state: { feedbackData: this.feedBackData, notificationData: this.notificationDetailsObj } });
  }

  public Oncancel(): void {
    this.router.navigateByUrl(this.mainPageLink);
  }

  public OnBack(): void {
    this.router.navigateByUrl(this.mainPageLink);
  }

  public downloadDocument(PIMID: string, fileExtension: string): void {
    this.customerservice.downloadPiosDocumentApi(PIMID, fileExtension);
  }

  public downloadAttachment(fileName: string, notificationId: string): void {
    this.customerservice.downloadLocalAttachmentApi(fileName, notificationId, this.contactNotificationId, this.publicKeyToken,true);
  }

  public getFormControl(ID: any): string {
    return 'formContolLabel' + ID;
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public isAttachmentUploaded(feedbackId: string): boolean {
    return this.ContactNotificationObj.CustomerFeedbackAttachment ? this.ContactNotificationObj.CustomerFeedbackAttachment.flat().some(att => att.feedbackAttachmentId === feedbackId): false;
  }

  public isNoAttachmentsVisible(): boolean {
    const hasLocalAttachments = this.customerDataObj?.NotificationAttachments &&
    this.customerDataObj.NotificationAttachments.length > 0;

    const hasGlobalAttachments = this.ContactNotificationObj?.DocumentEnabled === true &&
    this.customerDataObj?.NotificationDocuments &&
    this.customerDataObj.NotificationDocuments.length > 0 &&
    this.customerDataObj.NotificationDocuments[0]?.Title;

    return !hasLocalAttachments && !hasGlobalAttachments;
  }
}
